import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {AlertController, IonContent, ModalController} from '@ionic/angular';
import {DocumentModel} from '../../models/document.model';
import {CustomerModel} from '../../models/customer.model';
import {SiteModel} from '../../models/site.model';
import {ContactModel} from '../../models/contact.model';
import {LokijsService} from '../../services/database/lokijs.service';
import {PhotoDTOModel} from '../../models/photoDTO.model';
import {FindGeoLocationService} from '../../services/find-geo-location.service';
import {MobileConfigurationModel} from '../../models/mobile-configuration.model';
import {ConfigurationService} from '../../services/configuration.service';
import {PersistDocumentService} from '../../services/persist-document.service';
import {DocumentTypes} from '../../definitions/document-types';

@Component({
    selector: 'app-offhire',
    templateUrl: './offhire.page.html',
    styleUrls: ['./offhire.page.scss'],
})
export class OffhirePage implements OnInit {

    @Input() document: DocumentModel;
    @ViewChild('content') content: IonContent;
    documentTemp: DocumentModel;
    mobileConfig: MobileConfigurationModel;
    title: string;

    constructor(private customer: CustomerModel,
                private site: SiteModel,
                private contactModel: ContactModel,
                private sigContactModel: ContactModel,
                private alertController: AlertController,
                private modalController: ModalController,
                private loki: LokijsService,
                private findGeoLocation: FindGeoLocationService,
                private config: ConfigurationService,
                private persistDocService: PersistDocumentService,
                public docTypes: DocumentTypes) {
    }

    ngOnInit() {
        this.documentTemp = JSON.parse(JSON.stringify(this.document));
        if (!this.documentTemp.photosURL) {
            this.documentTemp.photosURL = new Array<PhotoDTOModel>();
        }
        this.mobileConfig = this.config.getMobileConfiguration();
    }

    ionViewDidEnter() {
        this.content.scrollToTop(200);
    }

    ionViewWillEnter() {
        
        this.title = 'Offhire';
        
        if( this.document.documentType === this.docTypes.BREAKDOWN ){
            this.title = 'Breakdown';
        }
        if( this.document.documentType === this.docTypes.BREAKDOWN_COLLECTION  ){
            this.title = 'Breakdown Collection';
        }
        

    }

    listenDocument(event: DocumentModel) {
        this.documentTemp = event;
        if (!(this.documentTemp.photosURL)) {
            this.documentTemp.photosURL = new Array<PhotoDTOModel>();
        }
    }

    listenCustomer(event) {
        this.documentTemp.customer = event;
        this.documentTemp.contact = new ContactModel();
        this.documentTemp.signatureContact = new ContactModel();
        this.documentTemp.site = new SiteModel();
        this.documentTemp.signature = null;
    }

    async cancelOffhire() {
        if (JSON.stringify((this.document)) !== JSON.stringify(this.documentTemp)) {
            const alert = await this.alertController.create({
                message: 'Do you want to cancel the ' + this.title + ' ?',
                backdropDismiss: false,
                buttons: [
                    {
                        text: 'No',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                        }
                    }, {
                        text: 'Yes',
                        handler: () => {
                            this.modalController.dismiss();
                        }
                    }
                ]
            });
            await alert.present();
        } else {
            this.modalController.dismiss();
        }
    }

    saveOffhire() {
        this.checkCollectionOffhire(this.documentTemp);
        if( this.documentTemp.replacementItem ){
            const detailLine = this.documentTemp.detailLines[0];
            this.documentTemp.replacementItem.location = detailLine.location;
            this.documentTemp.replacementItem.contractDocumentNumber = detailLine.contractDocumentNumber;
            //this.documentTemp.replacementItem.documentNumber = detailLine.contractDocumentNumber;
        }
        this.document = JSON.parse(JSON.stringify(this.documentTemp));
        this.persistDocService.persistDocument(this.document);
        this.modalController.dismiss(this.document);
    }

    private checkCollectionOffhire(doc: DocumentModel) {
        if(  doc.documentType === this.docTypes.BREAKDOWN ||  doc.documentType === this.docTypes.BREAKDOWN_COLLECTION  ){
            if (doc.signLater) {
                doc.documentType = this.docTypes.BREAKDOWN;
            } else {
                doc.documentType = this.docTypes.BREAKDOWN_COLLECTION;
            }
        }else{
            if (doc.signLater) {
                doc.documentType = this.docTypes.OFFHIRE;
            } else {
                doc.documentType = this.docTypes.COLLECTION;
            }
        }
    }
}
